import React from "react";
import { TextArea } from "semantic-ui-react";
import { WidgetProps } from '@rjsf/core';

interface IBaseInput extends WidgetProps {
  type?: string
}

const TextAreaWidget = (props: IBaseInput) => {
  const {
    id,
    disabled,
    value,
    onChange,
    onBlur,
    onFocus,
    options,
    autofocus,
    label,
    schema,
    readonly,
    placeholder,
    required,
    // ...inputProps
  } = props

  const { semanticProps = {} } = options;

  const _onChange = (e: any, { value }: any) => {
    return onChange(value === '' ? options.emptyValue : value)
  };

  const _onBlur = ({ target: { value } }: React.FocusEvent<HTMLInputElement>) => {
    return onBlur(id, value);
  }

  const _onFocus = ({ target: { value } }: React.FocusEvent<HTMLInputElement>) => {
    return onFocus(id, value);
  }

  if (readonly) {
    return <div> {value} </div>
  }

  return (
    <TextArea
      id={id}
      label={label || schema.title}
      placeholder={placeholder}
      disabled={disabled || readonly}
      value={value}
      required={required}
      autoFocus={autofocus}
      multiline={"true"}
      rows={Number(options.rows) || 5}
      onChange={_onChange}
      onBlur={_onBlur}
      onFocus={_onFocus}
      {...semanticProps}
    />
  )

}

TextAreaWidget.defaultProps = {
  type: "textarea",
  required: false,
  disabled: false,
  readOnly: false,
  autoFocus: false,
};

export default TextAreaWidget;
